<template>
  <div class="md-layout md-alignment-center-center gray-6 bg">
    <div class="md-layout-item md-size-33">
      <choose-password-form />
    </div>
  </div>
</template>

<script>
import ChoosePasswordForm from '../../components/auth/ChoosePasswordForm';

export default {
  name: 'choose-password',
  components: {
    ChoosePasswordForm
  }
};
</script>

<style>
</style>
